import { type Layout, getCompactor, moveElement } from 'react-grid-layout';

/** Keyboard gestures use the same collision handling and packing as pointer gestures. */
export function keyboardCanvasLayout(
  layout: Layout,
  id: string,
  key: string,
  mode: 'move' | 'resize',
  columns: number,
): Layout {
  const next = layout.map((item) => ({ ...item }));
  const item = next.find((entry) => entry.i === id);
  if (!item || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(key)) return layout;
  const dx = key === 'ArrowLeft' ? -1 : key === 'ArrowRight' ? 1 : 0;
  const dy = key === 'ArrowUp' ? -1 : key === 'ArrowDown' ? 1 : 0;
  const compactor = getCompactor('vertical');
  if (mode === 'resize') {
    item.w = Math.min(columns - item.x, Math.max(item.minW ?? 1, item.w + dx));
    item.h = Math.max(item.minH ?? 1, item.h + dy);
  } else {
    moveElement(
      next,
      item,
      Math.min(columns - item.w, Math.max(0, item.x + dx)),
      Math.max(0, item.y + dy),
      true,
      false,
      'vertical',
      columns,
    );
  }
  return compactor.compact(next, columns);
}
